// Tono semántico del estado de servicio, keyed por las keys del catálogo
// ESTADO_SERVICIO (@aid/shared). Antes había 3 copias con substring match
// (text.includes('BAJA') pintaba error cualquier value con BAJA adentro);
// esta es la única fuente para tablas, detalle y chips del cliente 360.
import { ESTADOS_SERVICIO, type EstadoServicioKey } from '@aid/shared';
import type { StatusTagTone } from '../components/StatusTag';

const TONOS_POR_ESTADO: Record<EstadoServicioKey, StatusTagTone> = {
  ACTIVO: 'success',
  ACTIVO_AL_CORTE: 'warning',
  SUSPENDIDO: 'warning',
  BAJA: 'error',
  PENDIENTE: 'info',
  BAJA_AL_CORTE: 'error',
};

export function tonoEstadoServicio(clave: string | null | undefined): StatusTagTone {
  const key = clave?.toUpperCase() as EstadoServicioKey | undefined;
  return key !== undefined && ESTADOS_SERVICIO.includes(key) ? TONOS_POR_ESTADO[key] : 'info';
}
